import { Injectable } from '@angular/core';
import { Router, CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { NbAuthService } from '@nebular/auth';
import { tap } from 'rxjs/operators';
import { Usuario } from '../../pages/admin/models/usuario';
import { Config } from '../config/config';
import { UserService } from '../services/userService/user.service';
import createAuth0Client, { Auth0Client } from '@auth0/auth0-spa-js';
import { environment as env } from '../../../environments/environment';

function until(conditionFunction) {

  const poll = resolve => {
    if (conditionFunction()) resolve();
    else setTimeout(_ => poll(resolve), 200);
  }

  return new Promise(poll);
}

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {

  authService: AuthService;
  userService: UserService;
  auth0: Auth0Client;
  rol: string;

  constructor(private router: Router, authService: AuthService, userService: UserService) {
    this.userService = userService;
    this.authService = authService;
    sessionStorage.clear();
    createAuth0Client({
      domain: env.auth.domain,
      client_id: env.auth.clientId,
      redirect_uri: env.auth.redirectUri,
      useRefreshTokens: true,
      response_type: 'web_message',
      //prompt: 'none',
    }).then(auth0Client => {
      this.auth0 = auth0Client;
      this.auth0.getTokenSilently().then(token => {
        this.auth0.getUser().then(user => {
          sessionStorage.setItem(Config.LocalStorage.auth0Id, user.sub);
          this.userService.setUsuario();
        });
      }).catch(err => {
        this.authService.logout({ returnTo: env.logInOut });
      })

      this.userService.getRole()
        .subscribe(rol => {
          this.rol = rol;
        });
    });
  }

  async canAccess(roles: string[], acceso?: number) {
    await until(_ => this.auth0 && sessionStorage.getItem(Config.LocalStorage.usuarioSeteado));
    return this.auth0.getTokenSilently().then(
      auth => {
        return this.auth0.isAuthenticated().then
          (
            authenticated => {
              if (!authenticated) {
                this.authService.logout({ returnTo: env.logInOut });
                return false;
              }
              if (!sessionStorage.getItem(Config.LocalStorage.usuarioLogueado)) {
                this.router.navigateByUrl('/activar-usuario');
                return false;
              }
              if (!this.userService.hasRole(roles) || (acceso && !this.userService.tieneAcceso(acceso))) {
                this.router.navigateByUrl('/');
                return false;
              }
              return true;
            }
          );
      }).catch(auth => {
        this.authService.logout({ returnTo: env.logInOut });
        return false;
      });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return route.data.acceso ? this.canAccess(route.data.roles, route.data.acceso) : this.canAccess(route.data.roles);
  }

  canLoad(route: Route) {
    return route.data.acceso ? this.canAccess(route.data.roles, route.data.acceso) : this.canAccess(route.data.roles);
  }
}
